import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function cancelExternalTrainingModuleImport(
   importId: number,
   common: CommonRequestOptions = {}
): Promise<void> {
   return makeRequest('post', `/external-training-modules/imports/${importId}/cancel`, {
      ...common,
   });
}
